var React = require('react');

function IconDiagnosticTampon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.5 12C11.0523 12 11.5 11.5523 11.5 11V4C11.5 2.89543 11.6046 2 10.5 2C9.39543 2 9.5 2.89543 9.5 4V11C9.5 11.5523 9.94772 12 10.5 12ZM10.5 0.5C8.567 0.5 8 2.067 8 4V13.2059C8 13.3683 8.13168 13.5 8.29412 13.5H12.7059C12.8683 13.5 13 13.3683 13 13.2059V4C13 2.067 12.433 0.5 10.5 0.5Z","fill":"#001D3B","key":0}),React.createElement("rect",{"x":"9.75","y":"12.5","width":"1.5","height":"8","rx":"0.75","fill":"#001D3B","key":1})]);
}

IconDiagnosticTampon.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = IconDiagnosticTampon;

IconDiagnosticTampon.default = IconDiagnosticTampon;
